import styles from './StepPrototyping.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

export interface StepDetail {
  no: string
  title: string
  text: string
}

export interface StepItem {
  sectionTitle: string
  sectionRead?: string
  step: StepDetail[]
}

interface Props {
  StepEach: StepItem[]
}

const Step: React.FC<Props> = ({ StepEach }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  const item = StepEach && StepEach.length > 0 ? StepEach[0] : { sectionTitle: '', sectionRead: '', step: [] }

  return (
    <section
      className={`${styles.step} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>{item.sectionTitle}</h2>
      <p className={styles.sectionRead}>{item.sectionRead}</p>
      <ul className={styles.stepList}>
        {item.step &&
          item.step.map((step, index) => (
            <li key={index} className={styles.stepList__item}>
              <div className={styles.stepList__item__no}>{step.no}</div>
              <div className={styles.stepList__item__area}>
                <h3 className={styles.stepList__item__area__title}>{step.title}</h3>
                <p className={styles.stepList__item__area__text}>{step.text}</p>
              </div>
            </li>
          ))}
      </ul>
      <div className={styles.toDownload}>
        <a href="/download/prototyping/" className={styles.toDownload__link}>
          <figure className={styles.toDownload__link__image}>
            <img
              src="/images/img/download/prototyping/thumbnail_prototyping.webp"
              alt="プロトタイピングサービス"
              width={280}
              height={157}
            />
          </figure>
          <div className={styles.toDownload__link__cts}>
            <p className={styles.toDownload__link__cts__sub}>サービス資料</p>
            <dl className={styles.toDownload__link__cts__item}>
              <dt className={styles.toDownload__link__cts__item__title}>プロトタイピングサービス</dt>
              <dd className={styles.toDownload__link__cts__item__text}>
                3つのプロトタイプの目的や解決できる課題の違い、活用例などをまとめた全16ページの資料です。是非ご覧ください。
              </dd>
            </dl>
          </div>
        </a>
      </div>
    </section>
  )
}

export default Step
